import React from "react";
import Image from "next/image";
import { CrossIcon } from "../../../public/assets/icons";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { Button } from "antd";
import { useIntl } from "react-intl";

const GetAppBanner = () => {
  const intl = useIntl();
  const [bannerVisibility] = useRecState<boolean>("getAppBanner");

  const handleCloseBanner = () => {
    _eventBus.emit({
      eventName: evtTree.GetAppBanner.CrossIcon.Click,
    });
  };

  const handleOpenApp = () => {
    _eventBus.emit({
      eventName: evtTree.GetAppBanner.GetOROpenApp.Click,
    });
  };
  return (
    <>
      {bannerVisibility ? (
        <div className="container banner-container">
          <div className="banner-logo">
            <Button
              style={{ padding: 0 }}
              type="text"
              onClick={handleCloseBanner}
            >
              <CrossIcon />
            </Button>
            {/* <button onClick={handleCloseBanner}>
              {""}
              <CrossIcon />
            </button> */}
            <Image
              width={50}
              height={50}
              src="/images/small-logo.png"
              alt="Small Logo"
            />
          </div>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <div className="banner-text">
              <h4>Etihad Rail</h4>
              <p> {intl.formatMessage({ id: "downloadBannerText" })}</p>
            </div>
            <Button
              type="primary"
              onClick={handleOpenApp}
              className="btn banner-get-btn"
            >
              Get App
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default GetAppBanner;
